import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'La Hoja de Ruta de 72 Horas',
    desc: 'Qué comer y qué hacer desde que despiertas hasta que duermes.'
  }, {
    title: 'El Elixir Iónico',
    desc: 'La receta exacta para hidratar tus células y deshinchar tu rostro al instante.'
  }, {
    title: "Lista de Compras 'Anti-Alarma'",
    desc: 'Alimentos que apagan la inflamación intestinal mecánicamente.'
  }, {
    title: 'Protocolo de Sueño de Emergencia',
    desc: 'Cómo activar el drenaje linfático profundo mientras descansas.'
  }, {
    title: 'Rutina de Descompresión Abdominal',
    desc: '2 minutos para liberar aire atrapado y tensión gástrica.'
  }];
  return <section className="bg-cream py-20 px-4" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <h2 className="text-3xl md:text-4xl text-center text-near-black mb-16" data-id="element-169">
          Lo que recibes hoy
        </h2>

        <div className="space-y-6" data-id="element-170">
          {items.map((item, index) => <div key={index} className="flex items-start bg-white p-6 md:p-8 shadow-sm border border-sage/20" data-id="element-171">
              <CheckCircle2 className="w-6 h-6 text-dark-green flex-shrink-0 mr-4 mt-1" data-id="element-172" />
              <div data-id="element-173">
                <h3 className="text-xl font-serif text-near-black mb-2" data-id="element-174">
                  {item.title}
                </h3>
                <p className="font-sans text-gray-600" data-id="element-175">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}